import { useState } from 'react';
import employeeInterestService from '../../services/employeeinterest.service';
import {
    STATUS_LABELS,
    STATUS_SEQUENCE,
    POSITION_LABELS,
    STORE_LABELS,
    HOURS_LABELS,
    EXPERIENCE_LABELS,
} from './constants';

export default function ApplicationDrawer({ application, onClose, onStatusUpdated }) {
    const [newStatus, setNewStatus] = useState(application.status);
    const [note, setNote] = useState('');
    const [saving, setSaving] = useState(false);

    async function handleStatusUpdate() {
        if (newStatus === application.status && !note.trim()) return;
        setSaving(true);
        try {
            await employeeInterestService.updateStatus(application.id, newStatus, note.trim());
            setNote('');
            onStatusUpdated();
        } catch (err) {
            console.error('Error updating application status', err);
            alert('No se pudo actualizar el estado.');
        } finally {
            setSaving(false);
        }
    }

    const sortedHistory = [...(application.statusHistory || [])].sort(
        (a, b) => new Date(b.changedAt) - new Date(a.changedAt)
    );

    return (
        <>
            <div className="drawer-backdrop" onClick={onClose} />
            <div className="drawer-panel">
                <div className="drawer-header">
                    <h2>{application.fullName}</h2>
                    <button type="button" className="drawer-close" onClick={onClose}>&times;</button>
                </div>

                <div className="drawer-body">
                    {/* Contact info */}
                    <section className="drawer-section">
                        <h3>Informacion de Contacto</h3>
                        <dl className="drawer-details">
                            <dt>Email</dt>
                            <dd><a href={`mailto:${application.email}`}>{application.email}</a></dd>
                            <dt>Telefono</dt>
                            <dd><a href={`tel:${application.phoneNumber}`}>{application.phoneNumber}</a></dd>
                        </dl>
                    </section>

                    {/* Position info */}
                    <section className="drawer-section">
                        <h3>Puesto</h3>
                        <dl className="drawer-details">
                            <dt>Posicion</dt>
                            <dd>{POSITION_LABELS[application.positionType] || application.positionType}</dd>
                            <dt>Tienda preferida</dt>
                            <dd>{STORE_LABELS[application.preferredStore] || application.preferredStore}</dd>
                            {application.interestArea && (
                                <>
                                    <dt>Area de interes</dt>
                                    <dd>{application.interestArea}</dd>
                                </>
                            )}
                        </dl>
                    </section>

                    {/* Availability */}
                    <section className="drawer-section">
                        <h3>Disponibilidad</h3>
                        <dl className="drawer-details">
                            <dt>Fecha de inicio</dt>
                            <dd>{application.startDate ? new Date(application.startDate).toLocaleDateString('es-MX') : '-'}</dd>
                            <dt>Horas por semana</dt>
                            <dd>{HOURS_LABELS[application.hoursPerWeek] || application.hoursPerWeek}</dd>
                        </dl>
                    </section>

                    {/* Experience */}
                    <section className="drawer-section">
                        <h3>Experiencia</h3>
                        <dl className="drawer-details">
                            <dt>Anos de experiencia</dt>
                            <dd>{EXPERIENCE_LABELS[application.yearsOfExperience] || application.yearsOfExperience}</dd>
                            {application.priorExperience && (
                                <>
                                    <dt>Experiencia previa</dt>
                                    <dd>{application.priorExperience}</dd>
                                </>
                            )}
                        </dl>
                        {application.resumeUrl && (
                            <a
                                href={application.resumeUrl}
                                target="_blank"
                                rel="noopener noreferrer"
                                className="resume-link"
                            >
                                Descargar CV / Resume
                            </a>
                        )}
                    </section>

                    {/* Status update */}
                    <section className="drawer-section drawer-status-section">
                        <h3>Actualizar Estado</h3>
                        <div className="drawer-status-form">
                            <select value={newStatus} onChange={(e) => setNewStatus(e.target.value)}>
                                {STATUS_SEQUENCE.map((s) => (
                                    <option key={s} value={s}>{STATUS_LABELS[s]}</option>
                                ))}
                            </select>
                            <textarea
                                placeholder="Nota (opcional)..."
                                value={note}
                                onChange={(e) => setNote(e.target.value)}
                                rows={2}
                            />
                            <button
                                type="button"
                                className="primaryButton"
                                onClick={handleStatusUpdate}
                                disabled={saving || (newStatus === application.status && !note.trim())}
                            >
                                {saving ? 'Guardando...' : 'Actualizar Estado'}
                            </button>
                        </div>
                    </section>

                    {/* Audit trail */}
                    {sortedHistory.length > 0 && (
                        <section className="drawer-section">
                            <h3>Historial</h3>
                            <div className="audit-trail">
                                {sortedHistory.map((entry, i) => (
                                    <div key={i} className="audit-entry">
                                        <span className={`job-app-status ${entry.status}`}>
                                            {STATUS_LABELS[entry.status] || entry.status}
                                        </span>
                                        {entry.note && <p className="audit-note">{entry.note}</p>}
                                        <span className="audit-meta">
                                            {entry.changedBy} — {new Date(entry.changedAt).toLocaleString('es-MX')}
                                        </span>
                                    </div>
                                ))}
                            </div>
                        </section>
                    )}
                </div>
            </div>
        </>
    );
}
